// Navbar.tsx
import React, { useState, useEffect, useRef } from 'react';
import './Navbar.scss';
import { MenuItem, MenuId } from '../../types/Header/types';
import {
  HomeOutlined,
  AppstoreOutlined,
  CodeOutlined,
  LaptopOutlined,
  CloudOutlined,
  BankOutlined,
  ApiOutlined,
  ToolOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  MessageOutlined,
  InfoCircleOutlined,
  HistoryOutlined,
  ContactsOutlined,
  UserOutlined,
  LoginOutlined
} from '@ant-design/icons';

const Navigation: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<MenuId | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // 记录哪些菜单需要向左展开（右侧空间不足时）
  const [openLeft, setOpenLeft] = useState<Record<string, boolean>>({});
  const navRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const navItems: MenuItem[] = [
    {
      id: 'home',
      title: '首页',
      link: '/',
      icon: 'home'
    },
    {
      id: 'products',
      title: '产品中心',
      icon: 'appstore',
      subMenu: [
        {
          id: 'software',
          title: '软件产品',
          icon: 'code',
          subMenu: [
            { id: 'software01', title: '云E投屏', link: '/products/software/dlna', icon: 'office' },
            // { id: 'software02', title: '云E助手', link: '/products/software/02', icon: 'design', hot: false },
            // { id: 'software03', title: '云短音通信软件', link: '/products/software/03', icon: 'tool', new: false }
          ]
        },
        // {
        //   id: 'cloud',
        //   title: '云服务',
        //   icon: 'cloud',
        //   subMenu: [
        //     { id: 'storage', title: '云存储服务', link: '/products/cloud/storage', icon: 'storage' },
        //     { id: 'compute', title: '云计算平台', link: '/products/cloud/compute', icon: 'compute' },
        //     { id: 'ai', title: 'AI云服务', link: '/products/cloud/ai', icon: 'ai', new: false }
        //   ]
        // }
      ]
    },
    // {
    //   id: 'solutions',
    //   title: '解决方案',
    //   icon: 'solution',
    //   subMenu: [
    //     {
    //       id: 'industry',
    //       title: '行业解决方案',
    //       icon: 'bank',
    //       subMenu: [
    //         { id: 'finance', title: '金融行业解决方案', link: '/solutions/industry/finance', icon: 'finance', hot: false },
    //         { id: 'education', title: '教育行业解决方案', link: '/solutions/industry/education', icon: 'education' },
    //         { id: 'healthcare', title: '医疗健康方案', link: '/solutions/industry/healthcare', icon: 'healthcare' }
    //       ]
    //     },
        // {
        //   id: 'tech',
        //   title: '技术解决方案',
        //   icon: 'api',
        //   subMenu: [
        //     { id: 'bigdata', title: '大数据解决方案', link: '/solutions/tech/bigdata', icon: 'data' },
        //     { id: 'iot', title: '物联网解决方案', link: '/solutions/tech/iot', icon: 'iot' }
        //   ]
        // },
        // {
        //   id: 'custom',
        //   title: '定制开发',
        //   icon: 'tool',
        //   subMenu: [
        //     { id: 'web', title: '企业网站定制', link: '/solutions/custom/web', icon: 'web' },
        //     { id: 'app', title: '移动应用开发', link: '/solutions/custom/app', icon: 'mobile', hot: true },
        //     { id: 'erp', title: 'ERP系统定制', link: '/solutions/custom/erp', icon: 'erp' }
        //   ]
        // }
      // ]
    // },
    // {
    //   id: 'services',
    //   title: '服务支持',
    //   icon: 'service',
    //   subMenu: [
    //     {
    //       id: 'support',
    //       title: '技术支持',
    //       icon: 'question',
    //       subMenu: [
    //         { id: 'online', title: '在线技术支持', link: '/services/support/online', icon: 'online' },
    //         { id: 'onsite', title: '现场技术支持', link: '/services/support/onsite', icon: 'onsite' }
    //       ]
    //     },
    //     {
    //       id: 'training',
    //       title: '培训服务',
    //       icon: 'read',
    //       subMenu: [
    //         { id: 'basic', title: '基础培训课程', link: '/services/training/basic', icon: 'basic' },
    //         { id: 'advanced', title: '高级技术培训', link: '/services/training/advanced', icon: 'advanced' },
    //         { id: 'certification', title: '认证培训计划', link: '/services/training/certification', icon: 'certification', new: false }
    //       ]
    //     },
    //     {
    //       id: 'consulting',
    //       title: '咨询服务',
    //       icon: 'message',
    //       subMenu: [
    //         { id: 'it', title: 'IT战略咨询', link: '/services/consulting/it', icon: 'strategy' },
    //         { id: 'digital', title: '数字化转型咨询', link: '/services/consulting/digital', icon: 'digital', hot: false },
    //         { id: 'security', title: '安全合规咨询', link: '/services/consulting/security', icon: 'security' }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'about',
    //   title: '关于我们',
    //   icon: 'info',
    //   subMenu: [
    //     {
    //       id: 'company',
    //       title: '团队简介',
    //       icon: 'info',
    //       subMenu: [
    //         { id: 'profile', title: '团队概况', link: '/about/company/profile', icon: 'profile' },
    //         { id: 'culture', title: '团队文化', link: '/about/company/culture', icon: 'culture' }
    //       ]
    //     },
    //     {
    //       id: 'history',
    //       title: '报告发布',
    //       icon: 'report',
    //       subMenu: [
    //         { id: 'report01', title: '产品报告', link: '/about/report/p01', icon: 'milestone' },
    //         { id: 'report02', title: '动态消息', link: '/about/report/p02', icon: 'event', hot: false }
    //       ]
    //     },
    //     {
    //       id: 'contact',
    //       title: '联系我们',
    //       icon: 'contact',
    //       subMenu: [
    //         { id: 'joinus', title: '加入我们', link: '/about/contact/joinus', icon: 'join', new: false }
    //       ]
    //     }
    //   ]
    // }
  ];

  const getIcon = (iconName?: string) => {
    switch (iconName) {
      case 'home': return <HomeOutlined />;
      case 'appstore': return <AppstoreOutlined />;
      case 'code': return <CodeOutlined />;
      case 'laptop': return <LaptopOutlined />;
      case 'cloud': return <CloudOutlined />;
      case 'solution': return <BankOutlined />;
      case 'api': return <ApiOutlined />;
      case 'tool': return <ToolOutlined />;
      case 'question': return <QuestionCircleOutlined />;
      case 'read': return <ReadOutlined />;
      case 'message': return <MessageOutlined />;
      case 'info': return <InfoCircleOutlined />;
      case 'history': return <HistoryOutlined />;
      case 'contact': return <ContactsOutlined />;
      default: return <AppstoreOutlined />;
    }
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleMouseEnter = (menuId: MenuId, event?: React.MouseEvent) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setActiveMenu(menuId);

    // 计算当前菜单项距离屏幕右侧的空间，判断子菜单是否需要向左展开
    if (event && !isMobile) {
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      const subMenuWidth = 220;
      const spaceRight = window.innerWidth - rect.right;

      // 如果右侧空间不足，标记该菜单为向左展开
      setOpenLeft(prev => ({
        ...prev,
        [menuId]: spaceRight < subMenuWidth + 20
      }));
    }
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setActiveMenu(null);
    }, 200);
  };

  const handleMenuClick = (menuId: MenuId) => {
    setActiveMenu(activeMenu === menuId ? null : menuId);
  };

  const renderMenuItems = (items: MenuItem[], level: number = 1) => {
    return (
      <ul className={`nav-level-${level}`}>
        {items.map((item) => (
          <li
            key={item.id}
            className={`
              nav-item
              level-${level}
              ${activeMenu === item.id ? 'active' : ''}
              ${item.hot ? 'hot' : ''}
              ${item.new ? 'new' : ''}
              ${openLeft[item.id] ? 'open-left' : ''}
            `}
            onMouseEnter={!isMobile ? (e) => handleMouseEnter(item.id, e) : undefined}
            onMouseLeave={!isMobile ? handleMouseLeave : undefined}
          >
            <a
              href={item.link || '#'}
              onClick={(e) => {
                if (isMobile && item.subMenu) {
                  e.preventDefault();
                  handleMenuClick(item.id);
                }
              }}
            >
              {level > 1 && <span className="menu-icon">{getIcon(item.icon)}</span>}
              {item.title}
              {(item.hot || item.new) && (
                <span className="menu-badge">
                  {item.hot && <span className="hot-badge">热门</span>}
                  {item.new && <span className="new-badge">新品</span>}
                </span>
              )}
            </a>

            {item.subMenu && (
              <div
                className={`sub-menu level-${level + 1} ${
                  activeMenu === item.id ||
                  (level === 1 && item.subMenu.some(sub => sub.id === activeMenu)) ? 'active' : ''
                } ${openLeft[item.id] ? 'open-left' : ''}`}
                onMouseEnter={!isMobile ? (e) => handleMouseEnter(item.id, e) : undefined}
                onMouseLeave={!isMobile ? handleMouseLeave : undefined}
              >
                {renderMenuItems(item.subMenu, level + 1)}
              </div>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      className="navigation-container"
      ref={navRef}
      onMouseLeave={!isMobile ? () => setActiveMenu(null) : undefined}
    >
      <div className="logo-area">
        <a href="/" className="site-logo">
          <img src="/iaya_logo2.png" alt="iaya.cn" className="logo-image" />
        </a>
      </div>

      {isMobile && (
        <button
          className="mobile-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
        >
          <span className="menu-text">
            {menuOpen ? '关闭' : '菜单'}
          </span>
        </button>
      )}

      <nav className={`main-navigation ${menuOpen ? 'open' : ''}`}>
        <div className="nav-menu-container">
          {renderMenuItems(navItems)}
        </div>

        {/* <div className="auth-buttons">
          <a href="https://socks5.g135.cn/login" className="login-btn">
            <LoginOutlined /> 登录
          </a>
          <a href="https://socks5.g135.cn/register" className="register-btn">
            <UserOutlined /> 注册
          </a>
        </div> */}
      </nav>
    </div>
  );
};

export default Navigation;